export default __webpack_public_path__ + "static/media/Image1.b2e19ddc.png";